/* BOTEA — interactions : apparitions, compteurs, carrousels, avant/après, barre d'achat collante */
(function () {
  'use strict';

  document.documentElement.classList.add('bt-js');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Apparition au défilement ---------- */
  var revealObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          if (entry.target.hasAttribute('data-bt-count')) countUp(entry.target);
          revealObserver.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 })
    : null;

  function initReveal(root) {
    root.querySelectorAll('[data-bt-reveal], [data-bt-count], .bt-stock, [data-bt-timeline]').forEach(function (el) {
      if (!revealObserver) { el.classList.add('is-in'); if (el.hasAttribute('data-bt-count')) countUp(el); return; }
      revealObserver.observe(el);
    });
  }

  /* ---------- Compteurs (ex : 96 %) ---------- */
  function countUp(el) {
    if (el.dataset.btDone) return;
    el.dataset.btDone = '1';
    var target = parseFloat(el.getAttribute('data-bt-count')) || 0;
    var suffix = el.getAttribute('data-bt-suffix') || '';
    if (reduceMotion) { el.textContent = target + suffix; return; }
    var start = null;
    var duration = 1600;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * eased) + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* ---------- Carrousels (avis, ingrédients) ---------- */
  function initCarousels(root) {
    root.querySelectorAll('[data-bt-carousel]').forEach(function (wrap) {
      if (wrap.dataset.btReady) return;
      wrap.dataset.btReady = '1';
      var track = wrap.querySelector('[data-bt-track]');
      var prev = wrap.querySelector('[data-bt-prev]');
      var next = wrap.querySelector('[data-bt-next]');
      var dots = wrap.querySelector('[data-bt-dots]');
      if (!track) return;

      function stepSize() {
        var card = track.children[0];
        if (!card) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
        if (dots) {
          var idx = Math.round(track.scrollLeft / stepSize());
          Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('is-active', i === idx); });
        }
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -stepSize(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: stepSize(), behavior: 'smooth' }); });
      if (dots) {
        dots.innerHTML = '';
        Array.prototype.forEach.call(track.children, function (_, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Aller à l’élément ' + (i + 1));
          b.addEventListener('click', function () { track.scrollTo({ left: i * stepSize(), behavior: 'smooth' }); });
          dots.appendChild(b);
        });
      }
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();

      var autoplay = parseInt(wrap.getAttribute('data-bt-autoplay'), 10);
      if (autoplay && !reduceMotion) {
        var timer;
        var play = function () {
          timer = setInterval(function () {
            var max = track.scrollWidth - track.clientWidth - 2;
            if (track.scrollLeft >= max) track.scrollTo({ left: 0, behavior: 'smooth' });
            else track.scrollBy({ left: stepSize(), behavior: 'smooth' });
          }, autoplay * 1000);
        };
        var stop = function () { clearInterval(timer); };
        wrap.addEventListener('mouseenter', stop);
        wrap.addEventListener('mouseleave', play);
        wrap.addEventListener('touchstart', stop, { passive: true });
        play();
      }
    });
  }

  /* ---------- Avant / après ---------- */
  function initBeforeAfter(root) {
    root.querySelectorAll('[data-bt-ba]').forEach(function (el) {
      var range = el.querySelector('input[type="range"]');
      if (!range || el.dataset.btReady) return;
      el.dataset.btReady = '1';
      var set = function () { el.style.setProperty('--bt-pos', range.value + '%'); };
      range.addEventListener('input', set);
      set();
    });
  }

  /* ---------- Barre d'achat collante ---------- */
  function initSticky(root) {
    root.querySelectorAll('[data-bt-sticky]').forEach(function (bar) {
      if (bar.dataset.btReady) return;
      bar.dataset.btReady = '1';
      var form = document.querySelector('product-info form[action*="/cart/add"], form[action*="/cart/add"][id^="product-form"]');
      var submit = form ? form.querySelector('[type="submit"]') : null;
      var anchor = submit || document.querySelector('.product__info-container');
      var btn = bar.querySelector('[data-bt-sticky-btn]');

      if (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var mode = bar.getAttribute('data-bt-sticky');
          if (mode === 'add' && submit && !submit.disabled) {
            submit.click();
          } else if (anchor) {
            anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
      }

      if (!anchor || !('IntersectionObserver' in window)) return;
      var footer = document.querySelector('.footer');
      var anchorVisible = true;
      var footerVisible = false;
      var refresh = function () {
        var show = !anchorVisible && !footerVisible && anchor.getBoundingClientRect().top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      };
      new IntersectionObserver(function (entries) {
        anchorVisible = entries[0].isIntersecting;
        refresh();
      }).observe(anchor);
      if (footer) {
        new IntersectionObserver(function (entries) {
          footerVisible = entries[0].isIntersecting;
          refresh();
        }).observe(footer);
      }
    });
  }

  /* ---------- Parallax léger sur les images marquées ---------- */
  function initParallax(root) {
    if (reduceMotion) return;
    var items = root.querySelectorAll('[data-bt-parallax]');
    if (!items.length) return;
    var ticking = false;
    var run = function () {
      items.forEach(function (el) {
        var r = el.getBoundingClientRect();
        var speed = parseFloat(el.getAttribute('data-bt-parallax')) || 0.08;
        var offset = (r.top + r.height / 2 - window.innerHeight / 2) * -speed;
        el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
      });
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(run); ticking = true; }
    }, { passive: true });
    run();
  }

  function init(root) {
    root = root || document;
    initReveal(root);
    initCarousels(root);
    initBeforeAfter(root);
    initSticky(root);
    initParallax(root);
  }

  /* Lien "#avis" : défile jusqu'à la section d'avis, quelle qu'elle soit */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href="#avis"]');
    if (!a) return;
    var target = document.querySelector('[id*="ss_reviews"], [id*="testimonial"], #bt-reviews');
    if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  /* Éditeur de thème : réinitialise quand une section est ajoutée/modifiée */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
